// @ts-strict-ignore
import isEmpty from 'lodash/isEmpty';

import {objToFormData} from 'common/util';

import {BaseClient} from '../utils/base-client';
import {appApiUrl} from '../utils';

class AvatarsClient extends BaseClient {
  buildEndpoint() {
    return appApiUrl(`avatars/`);
  }

  buildRequestBody(params) {
    const bodyKeys = [`avatar`];
    const bodyParams = {};
    bodyKeys.forEach((key) => {
      if (key in params) {
        bodyParams[key] = params[key];
      }
    });

    return isEmpty(bodyParams) ? null : objToFormData(bodyParams);
  }
  buildQueryParams(params) {
    if (params.projectId) {
      return {project_id: params.projectId};
    }
    return {organization_id: params.organizationId};
  }

  processResponse(response, _params) {
    return response.results;
  }
}

export const avatarsClient = new AvatarsClient();
